<template>
  <div class="homePage">
    <div class="fiex" :style="{ top: menuTop + 'px' }">
      <Navigation :active="8"></Navigation>
    </div>
    <div class="right">
      <!-- 等级 -->
      <div class="grade-box-fa">
        <div class="grade-box">
          <div class="grade-left">
            <div class="grade-top">
              <img
                class="head"
                v-if="$store.state.userInfo.avatarUrl"
                :src="`${$Url}${$store.state.userInfo.avatarUrl}`"
              />
              <img class="head" v-else src="@/assets/image/module/head.png" />
              <div class="name-box">
                <div class="name">{{ $store.state.userInfo.userName }}</div>
                <div class="name-grade" :title="getName">
                  <img
                    class="grade-img"
                    :src="require(`@/assets/image/homepage/v${this.grade}.png`)"
                  />
                  <span>{{ $t("module.credit.title1") }}</span>
                </div>
              </div>

              <div class="lj" @click="goUrl('/module/help')">
                {{ $t("module.credit.title2") }}
              </div>
            </div>
            <div class="bulb-box-fa">
              <div class="bulb-box">
                <img src="@/assets/image/module/bulb.png" />
                {{ $t("module.credit.title25") }}
              </div>
            </div>
            <div class="text-box" v-if="this.grade < 6">
              {{ $t("module.credit.title26")
              }}<span>{{ this.userInfo.credit }}</span
              >，{{ $t("module.credit.title27") }}V{{ this.grade + 1
              }}{{ $t("module.credit.title28") }}{{ $t("module.credit.title29")
              }}<span>{{ differenceNuber }}</span
              >{{ $t("module.credit.title30") }}
            </div>

            <div class="text-box" v-else>
              {{ $t("module.credit.title26")
              }}<span>{{ this.userInfo.credit }}</span
              >, {{ $t("module.credit.title31") }}
            </div>
          </div>
          <div class="grade-right">
            <div class="grade-herder">
              <div>{{ $t("module.credit.title4") }}</div>
              <span @click="goUrl('/module/credits')">{{
                $t("module.credit.title5")
              }}</span>
            </div>
            <div class="grade-content">
              <div class="baifen">
                <div class="number">
                  {{ incomePromote }}%<img
                    src="@/assets/image/module/arrow-top.png"
                  />
                </div>
                <div class="text">{{ $t("module.credit.title6") }}</div>
              </div>
              <div class="ring-box" @click="goUrl('/module/credits')">
                <el-progress
                  :width="123"
                  :show-text="false"
                  type="circle"
                  :percentage="percentage"
                  define-back-color="#fff"
                  :stroke-width="8"
                  color="#8948FF"
                ></el-progress>

                <div class="text-box">
                  <div class="number-box">{{ this.userInfo.credit }}</div>
                  <div class="texr">{{ $t("module.credit.title4") }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="progress" ref="progress">
          <div class="progress-icon">
            <el-progress
              :percentage="percentage2"
              :show-text="false"
              :stroke-width="11"
              define-back-color="#fff"
            ></el-progress>

            <div
              @click="active = 1"
              :class="[
                'div-box div-box1',
                { 'div-box-active': credit >= 0 },
                { 'div-box-active2': active == 1 },
              ]"
            >
              <div class="number">0</div>
              <div class="star"></div>
              <div class="text">V1</div>
              <div class="triangle"></div>
            </div>
            <div
              @click="active = 2"
              :class="[
                'div-box div-box2',
                { 'div-box-active': credit >= 61 },
                { 'div-box-active2': active == 2 },
              ]"
            >
              <div class="number">61</div>
              <div class="star"></div>
              <div class="text">V2</div>
              <div class="triangle"></div>
            </div>
            <div
              @click="active = 3"
              :class="[
                'div-box div-box3',
                { 'div-box-active': credit >= 101 },
                { 'div-box-active2': active == 3 },
              ]"
            >
              <div class="number">101</div>
              <div class="star"></div>
              <div class="text">V3</div>
              <div class="triangle"></div>
            </div>
            <div
              @click="active = 4"
              :class="[
                'div-box div-box4',
                { 'div-box-active': credit >= 201 },
                { 'div-box-active2': active == 4 },
              ]"
            >
              <div class="number">201</div>
              <div class="star"></div>
              <div class="text">V4</div>
              <div class="triangle"></div>
            </div>

            <div
              @click="active = 5"
              :class="[
                'div-box div-box5',
                { 'div-box-active': credit >= 501 },
                { 'div-box-active2': active == 5 },
              ]"
            >
              <div class="number">501</div>
              <div class="star"></div>
              <div class="text">V5</div>
              <div class="triangle"></div>
            </div>
            <div
              @click="active = 6"
              :class="[
                'div-box div-box6',
                { 'div-box-active': credit >= 801 },
                { 'div-box-active2': active == 6 },
              ]"
            >
              <div class="number">801</div>
              <div class="star"></div>
              <div class="text">V6</div>
              <div class="triangle"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 收益 -->
      <div class="income-box">
        <div class="title">{{ $t("module.credit.title7") }}</div>
        <div class="flex-box">
          <div
            :class="[
              { 'flex-item': item.type === active || active >= item.tType },
            ]"
            v-if="item.type === active || active >= item.tType"
            v-for="(item, index) in flexList"
          >
            <img class="bg" v-if="$i18n.locale === 'en'" :src="item.eUrl" />
            <img class="bg" v-else :src="item.url" />

            <div class="name" v-if="$i18n.locale === 'en'">
              {{ item.ename }}
            </div>
            <div class="name" v-else>{{ item.name }}</div>

            <div class="tips-box">
              <span>{{ $i18n.locale === "en" ? item.etips : item.tips }}</span>
              <img class="duihao" src="@/assets/image/common/duihao.png" />
            </div>
          </div>
        </div>
      </div>
      <!-- 信用值累计规则 -->
      <div class="cumulative-box">
        <div class="title">{{ $t("module.credit.title8") }}</div>

        <div class="p-box">
          <p>{{ $t("module.credit.title9") }}</p>
          <p>{{ $t("module.credit.title10") }}</p>
          <p>{{ $t("module.credit.title11") }}</p>
          <p>{{ $t("module.credit.title12") }}</p>
          <p>{{ $t("module.credit.title13") }}</p>
          <p>{{ $t("module.credit.title14") }}</p>
        </div>
      </div>

      <!-- 备注 -->
      <div class="remarks-box">
        <div class="title">{{ $t("module.credit.title15") }}</div>

        <div class="p-box">
          <p>{{ $t("module.credit.title16") }}</p>
          <p>{{ $t("module.credit.title17") }}</p>
          <p>{{ $t("module.credit.title18") }}</p>
          <p>{{ $t("module.credit.title19") }}</p>
          <p>{{ $t("module.credit.title20") }}</p>
          <p>{{ $t("module.credit.title21") }}</p>
          <p>{{ $t("module.credit.title22") }}</p>
          <p>{{ $t("module.credit.title23") }}</p>
          <p>{{ $t("module.credit.title24") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navigation from "@/components/Navigation/side";
import { getAccount } from "@/api/user";
export default {
  data() {
    return {
      userInfo: {},
      menuTop: 86,
      percentage: 0,
      percentage2: 0,
      grade: 1,
      credit: 0,
      flexList: [
        {
          url: require("@/assets/image/common/icon1.png"),
          eUrl: require("@/assets/image/common/eicon1.png"),
          name: "30天保护卡",
          ename: "30 days protect",
          tips: "首次完成注册",
          etips: "first register",
          type: 1,
        },
        {
          url: require("@/assets/image/common/icon2.png"),
          eUrl: require("@/assets/image/common/eicon2.png"),
          name: "额外奖励5%",
          ename: "Extra rewards 5%",
          tips: "完成任务",
          etips: "Complete task",
          type: 2,
        },
        {
          url: require("@/assets/image/common/icon2.png"),
          eUrl: require("@/assets/image/common/eicon2.png"),
          name: "额外奖励10%",
          ename: "Extra rewards 10%",
          tips: "完成任务",
          etips: "Complete task",
          type: 3,
        },
        {
          url: require("@/assets/image/common/icon2.png"),
          eUrl: require("@/assets/image/common/eicon2.png"),
          name: "额外奖励15%",
          ename: "Extra rewards 15%",
          tips: "完成任务",
          etips: "Complete task",
          type: 4,
        },
        {
          url: require("@/assets/image/common/icon2.png"),
          eUrl: require("@/assets/image/common/eicon2.png"),
          name: "额外奖励20%",
          ename: "Extra rewards 20%",
          tips: "完成任务",
          etips: "Complete task",
          type: 5,
        },
        {
          url: require("@/assets/image/common/icon2.png"),
          eUrl: require("@/assets/image/common/eicon2.png"),
          name: "额外奖励40%",
          ename: "Extra rewards 40%",
          tips: "完成任务",
          etips: "Complete task",
          type: 6,
        },
        {
          url: require("@/assets/image/common/icon3.png"),
          eUrl: require("@/assets/image/common/eicon3.png"),
          name: "金盾保护卡",
          ename: "Strong protection",
          tips: "完成任务",
          etips: "Complete task",
          tType: 2,
        },
        {
          url: require("@/assets/image/common/icon4.png"),
          eUrl: require("@/assets/image/common/eicon4.png"),
          name: "VIP快速审核通道",
          ename: "VIP channel",
          tips: "完成任务",
          etips: "Complete task",
          tType: 3,
        },
      ],
      active: 1,
      incomePromote: 0,
      differenceNuber: 0,
    };
  },
  components: { Navigation },
  computed: {
    getName() {
      let name = "铁牌";
      switch (this.grade) {
        case 1:
          name = "铁牌";
          break;
        case 2:
          name = "铜牌";
          break;
        case 3:
          name = "银牌";
          break;
        case 4:
          name = "金牌";
          break;
        case 5:
          name = "钻石";
          break;
        case 6:
          name = "王者";
          break;
      }

      return name + "会员";
    },
  },
  methods: {
    goUrl(path) {
      this.$router.push(path);
    },
    listenScroll() {
      console.log(
        "1111",
        document.body.offsetHeight - document.scrollingElement.scrollTop,
        window.innerHeight
      );
      if (
        document.body.offsetHeight - document.scrollingElement.scrollTop <=
        845
      ) {
        this.menuTop =
          document.body.offsetHeight -
          document.scrollingElement.scrollTop -
          815; //,添加el-menu-item,增加730的数值,减少707相同数值
      } else {
        this.menuTop = 86;
      }
    },

    //计算环形信用值
    changePercentage() {
      this.percentage = (this.userInfo.credit * 100) / 1000;
    },
    //长形信用值
    changePercentage2() {
      this.percentage2 = (this.userInfo.credit * 100) / 801;
    },

    getGrade() {
      if (this.userInfo.credit <= 60) {
        return 1;
      }
      if (61 <= this.userInfo.credit && this.userInfo.credit <= 100) {
        return 2;
      }
      if (101 <= this.userInfo.credit && this.userInfo.credit <= 200) {
        return 3;
      }
      if (201 <= this.userInfo.credit && this.userInfo.credit <= 500) {
        return 4;
      }
      if (501 <= this.userInfo.credit && this.userInfo.credit <= 800) {
        return 5;
      }
      if (801 <= this.userInfo.credit && this.userInfo.credit <= 1000) {
        return 6;
      }
      return 1;
    },
  },
  async created() {
    window.addEventListener("scroll", this.listenScroll);

    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.$store.commit("changeUserInfo", this.userInfo);
    } else {
      await getAccount().then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.$store.commit("changeUserInfo", this.userInfo);
          localStorage.setItem("userInfo", JSON.stringify(res.data));
        }
      });
    }

    //获取等级
    this.grade = this.getGrade();
    this.active = this.grade;

    switch (this.grade) {
      case 1:
        this.gradeName = "一般";
        this.frontNumber = 0;
        this.behindNumer = 60;
        this.incomePromote = 0;
        this.differenceNuber = 61 - this.userInfo.credit;
        break;
      case 2:
        this.gradeName = "中等";
        this.frontNumber = 61;
        this.behindNumer = 100;
        this.incomePromote = 5;
        this.differenceNuber = 101 - this.userInfo.credit;
        break;
      case 3:
        this.gradeName = "良好";
        this.frontNumber = 101;
        this.behindNumer = 200;
        this.incomePromote = 10;
        this.differenceNuber = 201 - this.userInfo.credit;
        break;
      case 4:
        this.gradeName = "优秀";
        this.frontNumber = 201;
        this.behindNumer = 500;
        this.incomePromote = 15;
        this.differenceNuber = 501 - this.userInfo.credit;
        break;
      case 5:
        this.gradeName = "钻石";
        this.frontNumber = 501;
        this.behindNumer = 800;
        this.incomePromote = 20;
        this.differenceNuber = 801 - this.userInfo.credit;
        break;
      case 6:
        this.gradeName = "王者";
        this.frontNumber = 801;
        this.behindNumer = 1000;
        this.incomePromote = 40;
        break;
    }
    this.changePercentage();
    this.changePercentage2();
    this.credit = this.userInfo.credit;
  },
  mounted() {},
  destroyed() {
    window.removeEventListener("scroll", this.listenScroll);
  },
};
</script>
<style scoped>
.circle >>> svg > path:nth-child(2) {
  stroke: url(#write);
}
.circle >>> .el-progress__text {
  display: none;
}
.progress >>> .el-progress-bar__inner {
  background: #8948ff;
}
</style>
<style lang="scss" scoped>
.homePage {
  min-height: 500px;
  display: flex;
  justify-content: flex-end;
  .fiex {
    position: fixed;
    left: 140px;
    transition: top ease 0.1s;
  }
  .right {
    flex-shrink: 0;
    width: calc(100% - 480px);
    margin-right: 140px;
    padding-top: 16px;
    //等级
    .grade-box-fa {
      width: 100%;
      height: 387px;
      align-items: center;
      background-image: url("../assets/image/module/bg3.png");
      background-size: cover;
      background-position: 100% 100%;
      background-repeat: no-repeat;
      border-radius: 4px;
      overflow: hidden;
      .grade-box {
        width: 100%;
        height: 254px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        .grade-left {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .grade-top {
            display: flex;
            align-items: center;
            margin-top: 31px;
            .head {
              width: 52px;
              height: 52px;
              border-radius: 26px;
              margin-left: 29px;
            }
            .name-box {
              display: flex;
              flex-direction: column;
              margin-left: 15px;
              margin-right: 15px;
              .name {
                font-size: 16px;
                color: #474f66;
              }
              .name-grade {
                display: flex;
                align-items: center;
                padding: 0 10px;
                height: 22px;
                border-radius: 11px;
                background: #d8d8fd;
                color: #8948ff;
                font-size: 12px;
                margin-top: 6px;
                .grade-img {
                  width: 16px;
                  height: 16px;
                  margin-right: 5px;
                }
              }
            }
            .lj {
              padding: 0 10px;
              height: 26px;
              line-height: 26px;
              background: #9257ff;
              font-size: 12px;
              color: #fff;
              border-radius: 2px;
              cursor: pointer;
            }
          }
          .bulb-box-fa {
            width: calc(100% - 60px);
            min-height: 40px;
            margin-left: 30px;
            .bulb-box {
              box-sizing: border-box;
              display: flex;
              align-items: center;
              min-height: 40px;
              padding: 0 10px;
              background: rgba(137, 72, 255, 0.08);
              border-radius: 4px 4px 4px 4px;
              color: #8948ff;
              font-size: 14px;
              line-height: 28px;
              img {
                width: 20px;
                height: 20px;
                margin-right: 9px;
              }
            }
          }
          .text-box {
            padding: 0 30px;
            font-size: 14px;
            color: #999999;
            span {
              font-size: 16px;
              color: #232323;
            }
          }
        }
        .grade-right {
          width: 421px;
          box-sizing: border-box;
          padding: 0 22px;
          flex-shrink: 0;
          margin-right: 20px;
          height: 205px;
          background-image: url("../assets/image/module/bg4.png");
          background-size: cover;
          background-position: 100% 100%;
          background-repeat: no-repeat;
          background-color: #ffffff;
          display: flex;
          flex-direction: column;
          border: 1px solid #fff;
          .grade-herder {
            width: 100%;
            border-bottom: 1px solid #ffffff;
            padding: 15px 0 13px 0;
            color: #474f66;
            font-size: 14px;
            display: flex;
            justify-content: space-between;
            flex-shrink: 0;
            span {
              color: #999999;
              cursor: pointer;
            }
          }
          .grade-content {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 100%;
            .baifen {
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-left: 20px;
              .number {
                font-size: 44px;
                font-weight: bolder;
                color: #8948ff;
                img {
                  width: 10px;
                  height: 10px;
                }
              }
              .text {
                color: #333333;
                font-size: 14px;
                margin-top: 6px;
              }
            }
            .ring-box {
              width: 140px;
              height: 140px;
              position: relative;
              margin-right: 20px;
              cursor: pointer;
              .el-progress {
                position: relative;
                left: 50%;
                top: 50%;
                transform: translateX(-50%) translateY(-50%);
              }
              .text-box {
                position: absolute;
                display: flex;
                flex-direction: column;
                align-items: center;
                left: 50%;
                top: 50%;
                transform: translateX(-50%) translateY(-50%);
                .number-box {
                  color: #8948ff;
                  font-size: 32px;
                  font-weight: bolder;
                }
                .text {
                  color: #232323;
                  font-size: 12px;
                  margin-top: 6px;
                }
              }
            }
          }
        }
      }
      .progress {
        width: calc(100% - 60px);
        margin-left: 30px;
        height: 81px;
        margin-top: 50px;
        .progress-icon {
          position: relative;
          width: 100%;
          .div-box {
            position: absolute;
            top: -25px;
            left: 0;
            width: 25px;
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
            .number {
              color: #474f66;
              font-size: 12px;
            }
            .text {
              color: #474f66;
              font-size: 12px;
              margin-top: 10px;
              height: 22px;
              width: 25px;
              text-align: center;
              line-height: 22px;
              border-radius: 2px;
            }
            .star {
              border: 2px solid #fff;
              border-radius: 12px;
              background-color: #fff;
              width: 16px;
              height: 16px;
              margin-top: 5px;
            }
            .triangle {
              width: 0;
              height: 0;
              border-left: 10px solid transparent;
              border-right: 10px solid transparent;
              border-bottom: 15px solid #fff;
              margin-top: 20px;
              display: none;
            }
          }
          .div-box-active {
            .star {
              border-color: #8948ff;
              background-color: #8948ff;
            }
          }
          .div-box-active2 {
            .triangle {
              display: block;
            }
            .text {
              color: #8948ff;
              background-color: #e6e4fc;
            }
            .star {
              border-color: #fff;
              background-color: #8948ff;
            }
          }
          .div-box:hover {
            .star {
              border-color: #fff;
            }
            .text {
              color: #8948ff;
              background-color: #e6e4fc;
            }
          }
          .div-box1 {
            left: -12.5px;
          }
          .div-box2 {
            left: calc(7.615% - 12.5px);
          }
          .div-box3 {
            left: calc(12.615% - 12.5px);
          }
          .div-box4 {
            left: calc(25.115% - 12.5px);
          }
          .div-box5 {
            left: calc(62.615% - 12.5px);
          }
          .div-box6 {
            left: calc(100% - 12.5px);
          }
        }
        .progress-grade {
          display: flex;
          justify-content: space-between;
          margin-top: 10px;
          font-size: 12px;
          font-weight: bold;
          color: #232323;
        }
        .progress-gap {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          color: #333333;
          margin-top: 10px;
          .number {
            font-size: 16px;
            font-weight: bold;
            color: #8948ff;
          }
        }
      }
    }
    //收益
    .income-box {
      width: 100%;
      background-color: #fff;
      padding: 22px 16px;
      box-sizing: border-box;
      .title {
        color: #474f66;
        font-size: 14px;
        font-weight: bolder;
      }
      .flex-box {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 12px;
        background-color: #fff;
        .flex-item {
          flex-shrink: 0;
          width: 294px;
          height: 120px;
          position: relative;
          margin-top: 40px;
          border-radius: 4px;
          margin-right: 24px;
          .bg {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            z-index: 1;
          }
          .name {
            color: #474f66;
            font-size: 16px;
            font-weight: bolder;
            margin-top: 41px;
            margin-left: 28px;
            position: relative;
            z-index: 2;
          }
          .tips-box {
            display: flex;
            align-items: center;
            position: relative;
            z-index: 2;
            color: #8948ff;
            font-size: 14px;
            font-weight: bolder;
            margin: 5px 0 0 28px;
            img {
              width: 16px;
              height: 16px;
              margin-left: 12px;
            }
          }
        }
      }
    }

    //信用值累计规则
    .cumulative-box {
      width: 100%;
      background-color: #fff;
      padding: 22px 16px;
      margin-top: 16px;
      box-sizing: border-box;
      .title {
        color: #474f66;
        font-size: 14px;
        font-weight: bolder;
      }
      .p-box {
        margin-bottom: 10px;
        p {
          color: #474f66;
          font-size: 14px;
          margin-top: 20px;
        }
      }
    }

    //备注
    .remarks-box {
      width: 100%;
      background-color: #fff;
      padding: 22px 16px;
      margin-top: 16px;
      box-sizing: border-box;
      margin-bottom: 20px;
      .title {
        color: #474f66;
        font-size: 14px;
        font-weight: bolder;
      }
      .p-box {
        margin-bottom: 10px;
        p {
          color: #474f66;
          font-size: 14px;
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
/* 媒体查询 */
@media only screen and (max-width: 1400px) {
  .homePage {
    .fiex {
      left: 70px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 340px);
      margin-right: 70px;
    }
  }
}

@media only screen and (max-width: 1300px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
    }
  }
}

@media only screen and (max-width: 1200px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
      .sign-box {
        flex-direction: column;
        .sign {
          width: 100%;
        }
      }
      .income-box {
        .flex-box {
          .flex-item {
            margin-right: 24px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1000px) {
  .homePage {
    .fiex {
      display: none;
    }
    .right {
      width: calc(100% - 30px);
      margin-right: 15px;
      .sign-box {
        display: none;
      }
      .sign-box-mobie {
        display: flex;
      }
      .income-box {
        .flex-box {
          .flex-item {
            margin-right: 12px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 750px) {
  .homePage {
    .fiex {
      display: none;
    }
    .right {
      .grade-box-fa {
        height: 560px;
        .grade-box {
          flex-direction: column;
          .grade-left {
            .bulb-box-fa {
              margin-top: 30px;
            }
            .text-box {
              margin-top: 20px;
            }
          }
          .grade-right {
            width: 100%;
            box-sizing: border-box;
            margin-right: 0;
            margin-top: 20px;
            .grade-content {
              box-sizing: border-box;
              padding: 0 20px;
              justify-content: space-between;
              .ring-box {
                margin: 0;
              }
              .baifen {
                margin: 0;
              }
            }
          }
        }
        .progress {
          margin-top: 220px;
        }
      }
    }
  }
}
@media only screen and (max-width: 680px) {
  .homePage {
    .fiex {
      display: none;
    }
    .right {
      .income-box {
        .flex-box {
          flex-direction: column;
          align-items: center;
          .flex-item {
            margin-top: 20px;
            margin-right: 0 !important;
          }
        }
      }

      .grade-box-fa {
        .progress {
          width: calc(100% - 30px);
          margin-left: 15px;
          .progress-icon {
            .div-box {
              position: absolute;
              top: -25px;
              left: 0;
              width: 25px;
              display: flex;
              flex-direction: column;
              align-items: center;
              cursor: pointer;
              .number {
                color: #474f66;
                font-size: 10px;
              }
              .text {
                color: #474f66;
                font-size: 10px;
                margin-top: 10px;
                height: 22px;
                text-align: center;
                line-height: 22px;
                border-radius: 2px;
              }
              .star {
                border: 2px solid #fff;
                border-radius: 12px;
                background-color: #fff;
                width: 12px;
                height: 12px;
                margin-top: 10px;
              }
              .triangle {
                width: 0;
                height: 0;
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                border-bottom: 15px solid #fff;
                margin-top: 27px;
                display: none;
              }
            }
            .div-box-active {
              .star {
                border-color: #8948ff;
                background-color: #8948ff;
              }
            }
            .div-box-active2 {
              .triangle {
                display: block;
              }
              .text {
                color: #8948ff;
                background-color: #e6e4fc;
              }
              .star {
                border-color: #fff;
                background-color: #8948ff;
              }
            }
            .div-box:hover {
              .star {
                border-color: #fff;
              }
              .text {
                color: #8948ff;
                background-color: #e6e4fc;
              }
            }
            .div-box1 {
              left: -12.5px;
            }
            .div-box2 {
              left: calc(7.615% - 12.5px);
            }
            .div-box3 {
              left: calc(12.615% - 12.5px);
            }
            .div-box4 {
              left: calc(25.115% - 12.5px);
            }
            .div-box5 {
              left: calc(62.615% - 12.5px);
            }
            .div-box6 {
              left: calc(100% - 12.5px);
            }
          }
        }
      }
    }
  }
}
</style>